<template>
  <div class="page">
    <PcHeader :activityIndex="1" v-if="!isMobile"></PcHeader>
    <div class="header_mobile" v-else>
      <div class="left"></div>
    </div>
    <div class="classics1">
      <div :class="[!isMobile ? 'qrcode-wrap' : 'qrcode-wrap-mobile']">
        <div class="qrcode"></div>
        <div class="font" v-if="!isMobile">立即扫码下载APP</div>
        <div class="font" v-else>长按二维码下载APP</div>
        <div class="app-info" v-if="!isMobile">
          <div class="app-info-item">
            <span class="label">应用名称：</span>
            <span class="value">益盟操盘手经典版</span>
          </div>
          <div class="app-info-item">
            <span class="label">应用版本：</span>
            <span class="value">v9.8.7</span>
          </div>
          <div class="app-info-item">
            <span class="label">开发者：</span>
            <span class="value">益盟股份有限公司</span>
          </div>
          <div class="app-info-item">
            <span class="label">功能介绍：</span>
            <a
              class="value link"
              href="javascript:void(0);"
              @click="gotoFeature"
              >查看详情</a
            >
          </div>
          <div class="app-info-item">
            <span class="label">隐私政策：</span>
            <a
              class="value link"
              href="javascript:void(0);"
              @click="gotoPrivite"
              >查看详情</a
            >
          </div>
          <div class="app-info-item">
            <span class="label">应用涉及权限：</span>
            <a
              class="value link"
              href="javascript:void(0);"
              @click="gotoPermission"
              >查看详情</a
            >
          </div>
          <div class="app-info-item">
            <span class="label">APP备案号：</span>
            <span class="value">沪ICP备06000340号-18A</span>
          </div>
        </div>
      </div>
    </div>
    <div class="classics2"></div>
    <div class="classics3"></div>
    <div class="classics4"></div>
    <Footer :isMobile="isMobile"></Footer>
    <!-- <div class="footer">
      <div class="code"></div>
      <div class="font" v-if="!isMobile">立即扫码下载APP</div>
      <div class="font" v-else>长按二维码下载APP</div>
      <div class="copy-message">
        <div class="copy">欢迎登录益盟官方网站www.emoney.cn &nbsp;投资有风险,入市需谨慎</div>
        <div class="tips">
          本页面内容最终解释权归益盟股份有限公司&nbsp;沪ICP备06000340
          <a
            href="http://www.emoney.cn/dianjin/abby/2013_1_kq/index.html"
          >风险提示</a>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
import PcHeader from '@/components/PcHeader'
import Footer from '@/components/Footer'

export default {
  data() {
    return {
      show: true,
      isMobile: /android|micromessenger|ipad|iphone/i.test(navigator.userAgent)
    }
  },
  components: {
    PcHeader,
    Footer
  },
  methods: {
    gotoFeature() {
      // this.$router.push({
      //   path: '/FeatureIntroduce'
      // })
      const routePath = '/PermissionIntroduce'
      const baseUrl = window.location.origin + window.location.pathname
      const fullUrl = `${baseUrl}#${routePath}`

      window.open(fullUrl, '_blank')
    },
    gotoPermission() {
      // this.$router.push({
      //   path: '/PermissionIntroduce'
      // })
      const routePath = '/PermissionIntroduce'
      const baseUrl = window.location.origin + window.location.pathname
      const fullUrl = `${baseUrl}#${routePath}`

      window.open(fullUrl, '_blank')
    },
    gotoPrivite() {
      let url = 'https://appstatic.emoney.cn/ymstock/privacy-ymstock/'
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.app-info {
  position: absolute;
  left: 100%;
  top: 0;
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  //background-color: #f9f9f9;
  border-radius: 8px;
  width: 360px;

  .app-info-item {
    display: flex;
    align-items: center;
  }

  .label {
    min-width: 120px;
    font-weight: bold;
    color: #555;
  }

  .value {
    flex: 1;
  }

  .link {
    color: #1677ff;
    text-decoration: none;
  }

  .link:hover {
    text-decoration: underline;
  }
}

.footer {
  overflow: hidden;
  height: 370px;
  background-color: #333;
  color: #999;
  .code {
    width: 130px;
    height: 130px;
    margin: 50px auto 0;
    background: url('./images/qrcode.png') no-repeat;
    background-size: 100%;
  }
  .font {
    color: #fff;
    font-size: 22px;
    margin-top: 15px;
  }
  .copy-message {
    font-size: 18px;
    // margin-top: 40px;
    padding: 40px 20px 0;
    > div {
      margin-top: 10px;
    }
  }
}
.classics1 {
  position: relative;
  // height: 530px;
  padding-bottom: 530/1920 * 100%;
  background: url('./images/classics1.png') no-repeat;
  background-size: cover;
  // .qrcode-wrap {
  //   position: absolute;
  //   left: 31%;
  //   bottom: 2%;
  //   .qrcode {
  //     width: 125px;
  //     height: 125px;
  //     background: url('./images/qrcode.png') no-repeat;
  //     background-size: 100%;
  //     margin: 0 auto;
  //   }
  //   .font {
  //     font-size: 22px;
  //     margin-top: 10px;
  //   }
  // }

  .qrcode-wrap {
    position: absolute;
    left: 31%;
    bottom: 7%;
    width: 8%;
    padding-bottom: 8%;
    .qrcode {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      padding-bottom: 100%;

      background: url('./images/qrcode.png') no-repeat;
      background-size: 100%;
      margin: 0 auto;
    }
    .font {
      position: absolute;
      left: -10.5%;
      bottom: -18%;
      width: 120%;
      font-size: 56%;
      font-weight: bold;
      white-space: nowrap;
    }
  }
}
.classics2 {
  position: relative;
  padding-bottom: 740/1920 * 100%;
  background: url('./images/classics2.png') no-repeat;
  background-size: cover;
}
.classics3 {
  position: relative;
  padding-bottom: 768/1920 * 100%;
  background: url('./images/classics3.png') no-repeat;
  background-size: cover;
}
.classics4 {
  position: relative;
  padding-bottom: 400/1920 * 100%;
  background: url('./images/classics4.png') no-repeat;
  background-size: cover;
}
.mobile {
  .classics1 {
    position: relative;
    height: 406px;
    background: url('./images/mc1.png') no-repeat;
    background-size: cover;
    .qrcode-wrap-mobile {
      position: absolute;
      left: 7%;
      bottom: 3%;
      .qrcode {
        width: 100px;
        height: 100px;
        background: url('./images/qrcode.png') no-repeat;
        background-size: 100%;
        margin: 0 auto;
      }
      .font {
        font-size: 20px;
        margin-top: 8px;
        white-space: nowrap;
      }
    }
  }
  .classics2 {
    position: relative;
    padding-bottom: 566/750 * 100%;
    background: url('./images/mc2.png') no-repeat;
    background-size: cover;
  }
  .classics3 {
    position: relative;
    padding-bottom: 566/750 * 100%;
    background: url('./images/mc3.png') no-repeat;
    background-size: cover;
  }
  .classics4 {
    position: relative;
    padding-bottom: 305/750 * 100%;
    background: url('./images/mc4.png') no-repeat;
    background-size: cover;
  }
}
.header_mobile {
  display: flex;
  padding: 20px 45px 25px 25px;
  justify-content: space-between;
  align-items: center;
  .left {
    width: 202px;
    height: 52px;
    background: url('./images/logo.png') no-repeat;
    background-size: cover;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Classics/Classics.vue